export default __webpack_public_path__ + "static/media/banco-antes-giros.74f62995.png";